import { SortOrder } from 'enums';
import { NewCentralFormType } from '../types';
import { getInitialSpecificFilterRowVals } from '../v2/specificFilterRows/filter-row';
import { createRowCategoryOptionsV3 } from '../v2/specificFilterRows/specific-filter-row-options-v3';
import { SAVED_FILTERS_VERSION } from '../search-grid-right-panel';

export const getInitialSpecificFilterRowValsV3 = () =>
  getInitialSpecificFilterRowVals(createRowCategoryOptionsV3()[0]);

export const INIT_VALS_V3: NewCentralFormType = {
  version: SAVED_FILTERS_VERSION,
  specificFilterRows: [getInitialSpecificFilterRowValsV3()],
  searchIn: [],
  order: SortOrder.DESC,
  page: 1,
  pageSize: 10,

  orderBy: 'archivalEntityType',
  includeSearchEntityTypes: {
    COLLECTIONS: true,
    AID: true,
    ARCHIVAL_UNIT_OR_EAD: true,
    ORIGINATOR: true,
  },

  includeSearchEntityTypes_V3: {
    ARCHIVAL_AID: true,
    ARCHIVAL_COLLECTION: true,
    EAD_NODE_UNIT: true,
    ORIGINATOR: true,
  },

  archivalUnitsFilters: { metadata: true, obsah: false, digital: false },
  selectedEvidenceUnitTypes: {
    operation: 'include',
    items: [],
  },
  selectedCollections: {
    operation: 'include',
    items: [],
  },
  selectedAids: {
    operation: 'include',
    items: [],
  },
};
